<div class="content">
  <h2 class="content-header" translate="header_billing-history"></h2>
  @if (isLoading$ | async) {
    <p class="text-muted text-center" translate="modal-billing-history_loading-transactions"></p>
  }

  @if ({transactions: transactions$ | async, plan: plan$ | async, credits: credits$ | async}; as asyncData) {
    <div class="clearfix test-html">
      @if (!asyncData.plan?.has_plan) {
        @for (credit of asyncData.credits; track credit) {
          <h4 class="pull-right">
            <span [innerHTML]="'modal-billing-history_course-credits' | translate: {available: credit.units_available, max: credit.max_video_mins}"></span>
          </h4>
        }
      }
      @if (asyncData.plan?.has_plan) {
        <h4 class="pull-right plan">
          <span translate="modal-billing-history_unlimited"></span>
          <small
            [ngClass]="{'red': asyncData.plan.has_ended}"
            class="exp">
            {{ 'modal-billing-history_expires' | translate: { date: asyncData.plan.ends_at | date: 'd MMM yyyy'} }}
          </small>
        </h4>
      }
    </div>
    <div class="clearfix row-fluid">
      <div class="span12">
        @if (asyncData.transactions?.length) {
          <table class="table">
            <thead>
              <tr class="active">
                <th width="140" translate="modal-billing-history_order"></th>
                <th translate="common_date"></th>
                <th translate="modal-billing-history_for"></th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              @for (transaction of asyncData.transactions; track transaction) {
                <tr class="invoice-top-row">
                  <td>
                    <button
                      type="button"
                      class="tertiary-btn receipt-btn"
                      [matTooltip]="'modal-billing-history_send-receipt' | translate"
                      (click)="sendEmail(transaction)">
                      @if (!transaction.emailSending) {
                        <i class="ficon-envelope-o"></i>
                      }
                      @if (transaction.emailSending) {
                        <i class="ficon-spinner ficon-spin"></i>
                      }
                    </button>&nbsp;
                    {{transaction.trans_id}}
                  </td>
                  <td>
                    {{transaction.created_at | date: 'mediumDate'}}
                  </td>
                  <td>
                    @if (transaction.payment_type !== 'refund') {
                      <span>{{transaction.group.name}}</span>
                    }
                    @if (transaction.payment_type === 'refund') {
                      <span>{{ 'tmodal-billing-history_refund-for-group' | translate : {group: transaction.group.name} }}</span>
                    }
                  </td>
                  <td class="text-right">
                    @if (transaction.payment_type === 'refund') {
                      <span>
                        <div><span translate="modal-billing-history_subtotal"></span>&nbsp;<span>-{{ transaction.subtotal | currency }}</span></div>
                        <div><span translate="modal-billing-history_tax"></span>&nbsp;<span>-{{ transaction.tax_amount | currency }}</span></div>
                        <div><strong translate="modal-billing-history_order-total"></strong><strong class="total">-{{ transaction.total | currency }}</strong></div>
                      </span>
                    }
                    @if (transaction.payment_type !== 'refund') {
                      <span>
                        <div><span translate="modal-billing-history_subtotal"></span>&nbsp;<span>{{ transaction.subtotal | currency }}</span></div>
                        <div><span translate="modal-billing-history_tax"></span>&nbsp;<span>{{ transaction.tax_amount | currency }}</span></div>
                        <div><strong translate="modal-billing-history_order-total"></strong>&nbsp;<strong class="total">{{ transaction.total | currency }}</strong></div>
                      </span>
                    }
                  </td>
                </tr>
              }
            </tbody>
          </table>
        }
        @if (asyncData.transactions?.length === 0) {
          <div translate="modal-billing-history_no-transaction"></div>
        }
      </div>
    </div>
  }
</div>
